import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Button from '@mui/material/Button';
import {Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, ListItemText, MenuItem, Select, TextField} from "@mui/material";
import {Link, useNavigate} from "react-router-dom";
import * as React from "react";
import {Fragment, useState} from "react";
import {UserType} from "../../service/Enums";
import axios from "axios";
import {API_URL} from "../../utils/constants";
import jwtInterceptor from "../../service/jwtInterceptor";
import {useToast} from "../../Context/ToastContext";

const PRIMARY_COLOR = "#000000";
const SECONDARY_COLOR = "#3F50B6";

const SELECT_MENU_PROPS = {
    disablePortal: false,
    sx: { zIndex: 1500 },
    PaperProps: { sx: { zIndex: 1501 } },
};

export const InscriptionUser = ({onSubmitted, userToEdit}) => {

    const INITIAL_STATE = {
        username: "",
        name: "",
        firstname: "",
        email: "",
        password: "",
        userType: UserType.USER.value,
        roles: []
    }

    const [hasError, setHasError] = useState(false);
    const [mailError, setMailError] = useState();
    const [erreur, setErreur] = useState('');
    const [modal, setModal] = useState({
        show: false,
        title: "",
        content: [""],
        error: false
    });
    // States for registration
    const [form, setForm] = React.useState(INITIAL_STATE);
    const [loading, setLoading] = useState(false);
    // States for checking the errors
    const [submitted, setSubmitted] = React.useState(false);
    const [error, setError] = React.useState(false);
    /*** password toogle hide show */
    const [passwordType, setPasswordType] = useState("password");
    const [availableRoles, setAvailableRoles] = useState([]);
    const [resetModalOpen, setResetModalOpen] = useState(false);
    const [resetPassword, setResetPassword] = useState("");
    const [resetPasswordConfirmation, setResetPasswordConfirmation] = useState("");
    const [resetPasswordError, setResetPasswordError] = useState("");
    const [resetLoading, setResetLoading] = useState(false);
    const toaster = useToast();

    React.useEffect(() => {
        const source = userToEdit?._source || userToEdit;
        if (source) {
            setForm((current) => ({
                ...current,
                username: source.username || "",
                name: source.name || "",
                firstname: source.firstname || "",
                email: source.email || "",
                userType: source.userType || UserType.USER.value,
                roles: source.roles || []
            }));
        } else {
            setForm(INITIAL_STATE);
        }
    }, [userToEdit]);

    React.useEffect(() => {
        jwtInterceptor.get(`${API_URL}/roles`)
            .then((response) => setAvailableRoles(response.data?.data?.details || response.data?.data || []))
            .catch(() => setAvailableRoles([]));
    }, []);

    const showMessage = (arg) => {


        setModal(arg);
        if (!arg.error) {
            // navigate("/");
        }
    }
    const navigate = useNavigate();


    const handleChange = (event) => {
        let val = (event.target.type === "checkbox") ? event.target.checked : event.target.value;
        if (event.target.name === "userType" && val === UserType.ADMIN.value) {
            handleFieldChange("roles", []);
        }
        handleFieldChange(event.target.name, val === "" ? INITIAL_STATE[event.target.name] : val);
    };

    const handleFieldChange = (field, value) => {
        setForm({
            ...form,
            [field]: value
        });
    }

    // Handling the form submission
    const handleSubmit = (e) => {
        setLoading(true);
        e.preventDefault();


        if (form.username === '' || form.name === '' || form.email === '' || (!userToEdit && form.password === '') || form.firstname === '') {
            setError(true);
            setSubmitted(false);
            setLoading(false); // Arrêter le chargement ici
        } else {
            setLoading(true); // Commencer le chargement si le formulaire est valide
            save({
                ...form,
                username: `${form.username}`.toLowerCase(),
            });
        }
    };

    const save = (payload) => {
        const userInformation = {
            ...payload,
            ...(userToEdit ? {} : {password: form.password}),
            userType: form.userType,
            ...(form.userType === UserType.USER.value ? {roles: form.roles} : {roles: []})
        };
        payload = {
            userInformation
        }

        jwtInterceptor
            [userToEdit ? "put" : "post"](userToEdit ? `${API_URL}/user/${(userToEdit._source || userToEdit).id || (userToEdit._source || userToEdit)._id}` : `${API_URL}/register`, payload)
            .then((res) => {
                setLoading(false);
                if (!res.data.error) {
                    setSubmitted(true);
                    setError(false);
                    toaster.notifySuccess(userToEdit
                        ? "Utilisateur modifié avec succès."
                        : "Utilisateur créé avec succès.");
                    onSubmitted();
                } else {
                    const errorMessage = res.data.message || 'Une erreur est survenue.';
                    setMailError(errorMessage);
                    toaster.notifyError(errorMessage);
                    showMessage({
                        show: true,
                        title: "Error",
                        content: [errorMessage],
                        error: true,
                    });
                }
            })
            .catch((err) => {
                const errorMessage = err.response?.data?.message || 'Une erreur est survenue.';
                setMailError(errorMessage);
                toaster.notifyError(errorMessage);
                setHasError(true); // Mise à jour de l'état hasError à true
                setErreur(err);
                setLoading(false);
            });
    };

    let emailMessage = () => {
        console.log("emailErr", error);
        return (
            <Fragment>
                <div className="error" style={{display: error ? "" : "none"}}>
                    {form.email === "" && !mailError && (
                        <span style={{color: "red"}}>
              Veuillez entrer votre adresse e-mail.
            </span>
                    )}
                </div>
                <div className="error"
                     style={!isEmailValid && form.email !== "" && !mailError ? {display: "block"} : {display: "none"}}>
                    {!isEmailValid && form.email !== "" && !mailError && (
                        <span style={{color: "red"}}>
              Veuillez entrer une adresse e-mail valide.
            </span>
                    )}
                </div>
                <div className="error"
                     style={mailError === "\"email\" must be a valid email" && form.email !== "" ? {display: "block"} : {display: "none"}}>
                    {mailError === "\"email\" must be a valid email" && form.email !== "" && (
                        <span style={{color: "red"}}>
              Veuillez entrer un adresse email Valide
            </span>
                    )}
                </div>
            </Fragment>
        );
    };

    let emailErrorMessage = null;

    if (hasError) {
        // Logique pour déterminer si l'erreur côté client doit être affichée
        emailErrorMessage = () => {
            if (
                erreur &&
                erreur.response &&
                erreur.response.data &&
                erreur.response.data.data &&
                erreur.response.data.data.details
            ) {
                const isEmailError = erreur.response.data.data.details.some((detail) => {
                    if (typeof detail === "string") {
                        return detail.includes("email");
                    } else if (typeof detail === "object" && detail !== null) {
                        // Gérer le cas où detail est un objet
                        // Par exemple, vérifier une propriété spécifique dans l'objet
                        // ou appliquer une logique appropriée selon vos besoins
                        // Ici, vous pouvez retourner false ou true selon votre logique
                        return false;
                    } else {
                        // Gérer les autres cas si nécessaire
                        return false;
                    }
                });

                return (
                    isEmailError && (
                        <div className="error">
            <span style={{color: "red"}}>
              {erreur.response.data.data.details.map((detail) => (
                  <span key={detail.message}>{detail.message ?? detail}</span>
              ))}
            </span>
                        </div>
                    )
                );
            }
        };
    } else {
        emailErrorMessage = emailMessage;
    }

    const isUsernameValid = form.username.length >= 3;

    let usernameMessage = () => {
        return (
            <Fragment>
                <div className="error" style={{display: error ? "" : "none"}}>
                    {form.username === "" && (
                        <span style={{color: "red"}}>
                Veuillez entrer votre pseudo.
              </span>
                    )}
                </div>
                <div className="error"
                     style={!isUsernameValid && form.username !== "" ? {display: "block"} : {display: "none"}}>
                    {!isUsernameValid && form.username !== "" && (
                        <span style={{color: "red"}}>
                Le pseudo doit comporter 3 caractères au minimum
              </span>
                    )}
                </div>
            </Fragment>
        );
    }
    let usernameErrorMessage = null;


    if (hasError) {
        usernameErrorMessage = () => {
            // Vérifier si erreur et erreur.response sont définis avant d'accéder à leurs propriétés
            if (
                erreur &&
                erreur.response &&
                erreur.response.data &&
                erreur.response.data.data &&
                erreur.response.data.data.details
            ) {
                const isPseudoError = erreur.response.data.data.details.some(
                    (detail) => {
                        if (typeof detail === "string") {
                            return detail.includes("pseudo");
                        } else if (typeof detail === "object" && detail !== null) {
                            // Gérer le cas où detail est un objet
                            // Par exemple, vérifier une propriété spécifique dans l'objet
                            // ou appliquer une logique appropriée selon vos besoins
                            // Ici, vous pouvez retourner false ou true selon votre logique
                            return false; // Par exemple, retourne false si l'objet ne contient pas d'erreur pseudo
                        } else {
                            // Gérer les autres cas si nécessaire
                            return false; // Par exemple, retourne false pour tout autre type de détail
                        }
                    }
                );
                return (
                    isPseudoError && (
                        <div className="error">
              <span style={{color: "red"}}>
                {erreur.response.data.data.details.map((detail) => (
                    <span key={detail.message}>{detail.message ?? detail}</span>
                ))}
              </span>
                        </div>
                    )
                );
            }
        };
    } else {
        // S'il n'y a pas d'erreur côté serveur, afficher l'erreur côté client
        usernameErrorMessage = usernameMessage;
    }
    ;

    // Showing success message
    const successMessage = () => {
        return (
            <div
                className="success"
                style={{
                    display: submitted ? '' : 'none',
                }}>
                <h1>Utilisateur {form.username} enregistré avec succès!!</h1>
            </div>
        );
    };

    // Showing error message if error is true
    const isEmailValid = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(
        form.email
    );
    const isPasswordValid =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]{8,}$/.test(
            form.password
        );

    const passwordMessage = () => {
        console.log("error2", error);
        return (
            <Fragment>
                <div className="error" style={{display: error ? "" : "none"}}>
                    {form.password === "" && (
                        <span style={{color: "red"}}>
              Veuillez entrer votre mot de passe.
            </span>
                    )}
                </div>
                <div className="error"
                     style={!isPasswordValid && form.password !== "" ? {display: "block"} : {display: "none"}}>
                    {!isPasswordValid && form.password !== "" && (
                        <span style={{color: "red"}}>
              Le mot de passe doit comporter au moins 8 caractères : une
              minuscule, une majuscule, un chiffre et un caractère spécial.
            </span>
                    )}
                </div>
            </Fragment>
        );
    };

    const isFirstnameValid = form.firstname.length >= 3;
    const firstnameMessage = () => {
        return (
            <Fragment>
                <div className="error" style={{display: error ? "" : "none"}}>
                    {form.firstname === "" && (
                        <span style={{color: "red"}}>Veuillez entrer votre prénom.</span>
                    )}
                </div>
                <div className="error"
                     style={!isFirstnameValid && form.firstname !== "" ? {display: "block"} : {display: "none"}}>
                    {!isFirstnameValid && form.firstname !== "" && (
                        <span style={{color: "red"}}>
              Le prénom doit comporter 3 caractères au minimum
            </span>
                    )}
                </div>
            </Fragment>
        );
    };

    const isNameValid = form.name.length >= 3;
    const nameMessage = () => {
        return (
            <Fragment>
                <div className="error" style={{display: error ? "" : "none"}}>
                    {form.name === "" && (
                        <span style={{color: "red"}}>Veuillez entrer votre nom.</span>
                    )}
                </div>
                <div className="error"
                     style={!isNameValid && form.name !== "" ? {display: "block"} : {display: "none"}}>
                    {!isNameValid && form.name !== "" && (
                        <span style={{color: "red"}}>
              Le nom doit comporter 3 caractères au minimum
            </span>
                    )}
                </div>
            </Fragment>
        );
    };

    /*** style variable ***/

    const fontWeightTitle = {
        fontWeight: "600"
    };
    const connexionBtn = {
        height: "40px",
        background: "#1B208C",
        color: "#fff",
        borderRadius: "8px",
        border: "none"
    }


    // const handlePasswordChange = (evnt) => {
    //   setPasswordInput(evnt.target.value);
    // }
    const togglePassword = () => {
        if (passwordType === "password") {
            setPasswordType("text")
            return;
        }
        setPasswordType("password")
    }

    const closeResetModal = () => {
        setResetModalOpen(false);
        setResetPassword("");
        setResetPasswordConfirmation("");
        setResetPasswordError("");
    };

    const resetUserPassword = async () => {
        const resetPasswordValid = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]{8,}$/.test(resetPassword);
        if (!resetPasswordValid || resetPassword !== resetPasswordConfirmation) {
            setResetPasswordError(resetPassword !== resetPasswordConfirmation
                ? "Les mots de passe ne correspondent pas."
                : "Le mot de passe doit comporter au moins 8 caractères : une minuscule, une majuscule, un chiffre et un caractère spécial.");
            return;
        }

        const source = userToEdit?._source || userToEdit;
        const userId = source?.id || source?._id;
        if (!userId) {
            setResetPasswordError("Impossible d'identifier cet utilisateur.");
            return;
        }

        setResetLoading(true);
        try {
            await jwtInterceptor.put(`${API_URL}/user/${userId}`, {
                userInformation: {password: resetPassword}
            });
            toaster.notifySuccess("Mot de passe réinitialisé avec succès.");
            closeResetModal();
        } catch (err) {
            setResetPasswordError(err.response?.data?.message || "La réinitialisation du mot de passe a échoué.");
        } finally {
            setResetLoading(false);
        }
    };

    return (
        <>
            <Dialog open={resetModalOpen} onClose={closeResetModal} fullWidth maxWidth="sm">
                <DialogTitle>Réinitialiser le mot de passe</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        fullWidth
                        className="mt-2"
                        label="Nouveau mot de passe"
                        type="password"
                        value={resetPassword}
                        onChange={(event) => {
                            setResetPassword(event.target.value);
                            setResetPasswordError("");
                        }}
                    />
                    <TextField
                        fullWidth
                        className="mt-3"
                        label="Confirmer le mot de passe"
                        type="password"
                        value={resetPasswordConfirmation}
                        onChange={(event) => {
                            setResetPasswordConfirmation(event.target.value);
                            setResetPasswordError("");
                        }}
                    />
                    {resetPasswordError && <div className="error mt-2" style={{color: "red"}}>{resetPasswordError}</div>}
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeResetModal} disabled={resetLoading}>Annuler</Button>
                    <Button onClick={resetUserPassword} variant="contained" disabled={resetLoading}>
                        {resetLoading ? <CircularProgress size={22}/> : "Réinitialiser"}
                    </Button>
                </DialogActions>
            </Dialog>

            <div className="w-auto h-auto">
            <form onSubmit={handleSubmit}>
                <TextField
                    fullWidth
                    className="mb-3"
                    label="E-mail *"
                    onChange={handleChange}
                    type="text"
                    placeholder="e-mail"
                    name="email"
                    value={form.email}
                />
                {hasError && !error && emailErrorMessage()}
                {(error || !hasError) && emailMessage()}

                <TextField
                    fullWidth
                    className="mb-3"
                    label="pseudo *"
                    onChange={handleChange}
                    type="text"
                    placeholder="pseudo"
                    name="username"
                    value={form.username}
                />
                {hasError && !error && usernameErrorMessage()}
                {(error || !hasError) && usernameMessage()}

                {!userToEdit && <TextField
                    fullWidth
                    className="mb-3"
                    label="Mot de passe *"
                    onChange={handleChange}
                    type={passwordType}
                    placeholder="mot de passe"
                    name="password"
                    value={form.password}

                    InputProps={{
                        endAdornment: (
                            <button type="button" className="btn border-0 outline-0 bg-transparent" onClick={togglePassword}>
                                {passwordType === "password" ? <VisibilityOffIcon/> : <VisibilityIcon/>}
                            </button>
                        )
                    }}
                />}
                {!userToEdit && passwordMessage()}
                {userToEdit && (
                    <div className="mb-3">
                        <Button
                            type="button"
                            variant="text"
                            onClick={() => setResetModalOpen(true)}
                            sx={{padding: 0, textTransform: "none"}}
                        >
                            Réinitialiser le mot de passe
                        </Button>
                    </div>
                )}

                <TextField
                    fullWidth
                    className="mb-4"
                    label="Nom *"
                    onChange={handleChange}
                    type="text"
                    placeholder="nom"
                    name="name"
                    value={form.name}
                />
                {nameMessage()}

                <TextField
                    fullWidth
                    className="mb-4"
                    label="prénom *"
                    onChange={handleChange}
                    type="text"
                    placeholder="prénom"
                    name="firstname"
                    value={form.firstname}
                />
                {firstnameMessage()}
                <FormControl
                    fullWidth
                    className="mb-3">
                    <InputLabel id="user-type-label">Type User *</InputLabel>
                    <Select
                        labelId="user-type-label"
                        label="Type User *"
                        name="userType"
                        value={form.userType}
                        onChange={handleChange}
                    >
                        <MenuItem value={UserType.USER.value}>User</MenuItem>
                        <MenuItem value={UserType.ADMIN.value}>Admin</MenuItem>
                    </Select>
                </FormControl>
                {form.userType === UserType.USER.value && <FormControl fullWidth className="mb-3">
                    <InputLabel id="user-roles-label">Rôles</InputLabel>
                    <Select
                        labelId="user-roles-label"
                        multiple
                        value={form.roles}
                        label="Rôles"
                        onChange={(event) => handleFieldChange("roles", event.target.value)}
                        MenuProps={SELECT_MENU_PROPS}
                        renderValue={(selected) => availableRoles
                            .filter((role) => selected.includes(role._id))
                            .map((role) => role.name)
                            .join(", ")}
                    >
                        {availableRoles.map((role) => (
                            <MenuItem key={role._id} value={role._id}>
                                <Checkbox checked={form.roles.includes(role._id)} />
                                <ListItemText primary={`${role.name} (${role.userType})`} />
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>}
                <div className="mb-3">
                    <Button
                        type="submit"
                        className="w-100 mb-2"
                        disabled={loading}
                        sx={{ backgroundColor: PRIMARY_COLOR, "&:hover": { backgroundColor: "#222222" }, color: "#fff" }}
                    >
                        {loading ? <CircularProgress/> : "Enregistrer"}
                    </Button>
                </div>
            </form>
            </div>
        </>

    );
}